import type { ForwardedRef } from 'react';
import React, { forwardRef } from 'react';
import type { LinkProps as NextLinkProps } from 'next/link';
import Link from 'next/link';

type BaseProps = {
  children: React.ReactNode;
  className?: string;
};

type ActionProps = BaseProps &
  (
    | (React.ButtonHTMLAttributes<HTMLButtonElement> & {
        as: 'button';
      })
    | (Omit<NextLinkProps, 'as'> & {
        as: 'link';
      })
    | (React.HTMLProps<HTMLDivElement> & {
        as: 'div';
      })
  );

export const PolymorphicComponent = forwardRef(
  (
    { className, ...props }: ActionProps,
    ref: ForwardedRef<HTMLButtonElement | HTMLAnchorElement | HTMLDivElement>,
  ) => {
    if (props.as === 'link') {
      const { as: _as, ...rest } = props;
      return (
        <Link ref={ref as ForwardedRef<HTMLAnchorElement>} className={className} {...rest}>
          {rest.children}
        </Link>
      );
    } else if (props.as === 'div') {
      const { as: _as, ...rest } = props;
      return <div ref={ref as ForwardedRef<HTMLDivElement>} className={className} {...rest} />;
    } else {
      const { as: _as, ...rest } = props;
      return (
        <button ref={ref as ForwardedRef<HTMLButtonElement>} className={className} {...rest} />
      );
    }
  },
);

PolymorphicComponent.displayName = 'PolymorphicComponent';
